import { render, staticRenderFns } from "./SettingsGeneralPluginsTab.vue?vue&type=template&id=e5e71330&scoped=true&"
import script from "./SettingsGeneralPluginsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsGeneralPluginsTab.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGeneralPluginsTab.vue?vue&type=style&index=0&id=e5e71330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e71330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VIcon,VSimpleTable})
